import React, { useState } from "react";
import Dialog, { DialogOptions } from "~/components/Dialog";

const SelectDropdown = ({
  options = [],
  value,
  onChange,
  valueIcon,
  placeholder = "Select",
  className = "",
  fullWidth = false,
}) => {
  const [displayDropdown, setDisplayDropdown] = useState(false);

  const selected = options.find((option) => option.value === value);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setDisplayDropdown(false);
  };

  const dialogClasses = fullWidth ? "dialog--fw dialog--left" : "dialog--left";

  return (
    <div
      className={`submission-selector ${fullWidth ? "submission-selector--fw" : ""} ${className}`.trim()}
      onClick={() => setDisplayDropdown(!displayDropdown)}
    >
      <div className="submission-selector__content">
        {valueIcon}
        <span className="submission-selector__label">{selected?.label ?? placeholder}</span>
        <i className="solid solid-budicon-chevron-bottom submission-selector__chevron" />
      </div>
      {displayDropdown && (
        <Dialog setOpen={setDisplayDropdown} dialogClasses={dialogClasses}>
          <DialogOptions>
            {options.map((option, index) => (
              <div
                key={option.key ?? index}
                className="dialog__item flex align-items-center gap--8"
                onClick={() => handleSelect(option.value)}
              >
                {option.icon}
                <span className="submission-selector__label selector__label--sm">
                  {option.label}
                </span>
                {option.endIcons}
              </div>
            ))}
          </DialogOptions>
        </Dialog>
      )}
    </div>
  );
};

export default SelectDropdown;
